<template>
    <div>
        <el-form :rules="rules" ref="form" :model="form" label-width="90px" class="event-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="知识分类" prop="knowledgeSort">
                        <el-cascader ref="knowledgeSort" v-model="form.knowledgeSort" :props="propsKnowledgeData"></el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="服务目录" >
                        <el-popover
                            placement="left"
                            trigger="hover"
                            >
                            <el-tree  @check="getSelectArray"
                                      show-checkbox :load="loadNodeOnce"
                                      :props="defaultPropsOnce" lazy node-key="value"
                                      :default-checked-keys="defaultCheckedValues"
                                      class="form-common"></el-tree>
                            <span :class="showRedColor?'':'redColor'" class="serveList common-input" slot="reference">{{serveListName}}</span>
                        </el-popover>
                        <!-- <el-cascader ref="serveList" v-model="serveList" :props="propsServeData"></el-cascader> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="知识来源" prop="Origin">
                        <el-select v-model="form.Origin" placeholder="请选择">
                            <el-option v-for="item in knowledgeDic" :key="item.id" :label="item.cname"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="标识为FAQ" prop="IsFaq">
                        <el-select v-model="form.IsFaq" placeholder="请选择" class="form-common">
                            <el-option v-for="item in signDic" :key="item.id" :label="item.cname"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="请求标题" prop="Title">
                        <el-input type="text" placeholder="请输入请求标题" v-model="form.Title" class="form-common"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" ></el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="详细描述" >
                        <!-- <ueditor @getUeContent="getUeContent" :description.sync="form.Body"></ueditor> -->

                        <ueditor v-model="form.Body" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="标签">
                        <el-input v-model="label" @change="loadData" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--附件-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件">
                        <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit" :disabled="isSubmit">提交</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"
    import commonService from "../../services/common.service";
    import services from "./knowledge.service";
    import inputFile from "../common/inputFile.vue"
    import { getRules } from "./knowledge.rules";
    const rules = getRules();
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            parentNumber:String,
            message:Object,
            callback:Function,

        },
        components:{ ueditor,inputFile },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //知识来源
            knowledgeDic(){
                return this.dictionary.KnowledgeOrigin;
            },
            // 标识为FAQ
            signDic(){
                return this.dictionary.KnowledgeFaq;
            },
        },
        data() {
            return {
                formName:"form",
                rules:rules,
                form:{
                    Origin:"",
                    IsFaq:"",
                    Title:"",
                    Body:"",
                    Keyword:'',
                    CreateUser:"",
                    UpdateUser:"",
                    Attachment:[],
                    CategoryId:"",
                    ServiceId:"",
                    knowledgeSort:[],
                    serveListName:'',
                },
                attachment:[],    // 存放上传的附件
                isKnowledge:false,
                label:"",//标签
                isSubmit:false,
                knowledgeSort:[],// 知识分类
                propsKnowledgeData: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        const { level } = node;
                        if(level<1){
                            services.getSortListMes({"type":"15"}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }else{
                            services.getChildSortListMes({"parentId":node.data.value}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }
                    }
                },
                serveList:[],// 服务目录
                propsServeData: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        const { level } = node;
                        let param ={
                            "parentNumber":''
                        }
                        if(level>0){
                            param.parentNumber = node.data.value;
                        }
                        services.getServeListMes(param).then(res => {
                            let nodes = [];
                            res.list.forEach(item=>{
                                nodes.push({value: item.serialNumber,label: item.title,leaf:!item.hasChildren})
                            })
                            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                            resolve(nodes);
                        }).catch(err => {
                            this.$message.error(err.message);
                        }).finally(() => {
                            this.loading = false;
                        })
                    }
                },
                // knowledgeOrigin:[],//知识来源
                // titleFAQ:[],//FAQ标识
                defaultPropsOnce: {
                    label: 'title',
                    isLeaf: 'hasChildren',
                },
                defaultCheckedValues:[],
                serveListName:'',
                showRedColor:true,
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    // serverUrl: 'http://35.201.165.105:8000/controller.php'/cr/v1/review
                    // serverUrl:Config.baseURL+"upload",
                    // serverUrl:'http://wedof.beta.autoai.com/upload/'
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        mounted() {
            // this.getKnowledgeOrigin();
            // this.getTitleFAQ();
            if(this.type == "edit"){
                this.$modal.title = "修改知识";
                this.getDetail();
            }else{
                this.form.Origin = ''+this.knowledgeDic[0].id;
            };
            if (this.parentNumber) {
                this.$modal.title='提交为知识'
                this.getDetails()
            }
        },
        methods: {
            loadData(){//获取关键字
                this.form.Keyword=this.label;
            },
            // 详情默认显示
            getDetail(){
                services.knowledgeDetail({ "KnowledgeId":this.message.KnowledgeId,"Version":this.message.Version}).then(res => {
                    res.Origin = ""+res.Origin;
                    res.IsFaq = ""+res.IsFaq;
                    // res.serveListName = res.ServiceName;
                    this.$refs.knowledgeSort._data.inputValue = res.CategoryName;
                    // this.form.serveListName = res.ServiceName;
                    this.form =  res;
                    this.label = res.Keyword;
                    this.knowledgeSort.push(res.CategoryId);
                    this.form.knowledgeSort=this.knowledgeSort;
                    this.serveList = res.ServiceId;
                    this.attachment = res.Attachment;
                    // this.form =  res;
                    this.form.serveListName = res.ServiceName;
                    this.serveListName = res.ServiceName;
                    this.defaultCheckedValues=res.ServiceId
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            submit(){
                this.isSubmit=true
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    this.showRedColor = valid;
                    if(valid){
                        if (!this.serveListName){
                            this.isSubmit=false
                            this.$message.error("服务目录不可为空")
                        } else{
                            this.form.CategoryId = this.form.knowledgeSort[this.form.knowledgeSort.length-1];
                            this.form.ServiceId = this.serveList;
                            this.form.Attachment = this.attachment;
                            this.form.CreateUser = localStorage.internalUserid;
                            this.form.UpdateUser = localStorage.internalUserid;
                            if (this.closeBtnInSolution){
                                services.addKnowledge(this.form).then(res => {

                                    this.$message.success("知识创建成功");
                                    this.close(true);

                                }).catch(err => {
                                    this.$message.error(err.message);
                                })
                            }
                            if(this.type == 'edit'){
                                this.form.CreateUser = this.message.CreateUser;
                                services.knowledgeUpdate(this.form).then(res => {
                                    this.$message.success("知识修改成功");
                                    this.close(true);
                                }).catch(err => {
                                    this.$message.error(err.message);
                                })
                            }else{
                                services.addKnowledge(this.form).then(res => {
                                    this.$message.success("知识创建成功");
                                    this.close(true);

                                }).catch(err => {
                                    this.$message.error(err.message);
                                })
                            }
                        }

                    }else{
                        this.isSubmit=false
                        this.$message.error("*为必填项，请填写完全")
                    };
                    return valid;
                })
            },

            // 获取编辑器内容
            // getUeContent(data){
            //     this.form.Body = data;
            // },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                  // console.log('编辑器内容发生了变化:', editorInstance.getContent());getContentTxt()
                  // _this.form.Body = editorInstance.getContent()
                   _this.form.Body = editorInstance.getContent()
                });
            },
            getFiles(val){
                this.attachment = val;
            },
            // fileChange(e){
            //     let files = e.target.files || e.dataTransfer.files;
            //     if (!files.length){
            //         return;
            //     };
            //     this.form.attachment = files[0];
            //     let params = {
            //         file_name:files[0]
            //     };
            //     commonService.uploading(params).then(res => {
            //         this.attachment = [];
            //         let file =  res;
            //         this.attachment.push({
            //             name:file.file_name,
            //             url:file.download_url
            //         })
            //         this.$message.success("文件上传成功");
            //     }).catch( err => {
            //         this.$message.error(err.message);
            //     })
            // },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            getSelectArray(data1,data2){
                this.serveList = [];
                this.form.serveListName = '';
                this.serveListName = '';
                data2.checkedNodes.forEach((item,index)=>{
                    this.serveList.push(item.value);
                    if(index == data2.checkedNodes.length-1){
                        this.form.serveListName = this.form.serveListName + item.title;
                        this.serveListName = this.serveListName + item.title;
                    }else{
                        this.form.serveListName = this.form.serveListName + item.title+',';
                        this.serveListName = this.serveListName + item.title+',';

                    }
                })
            },
            loadNodeOnce(node, resolve) {//加载服务目录列表
                if (node.level === 0) {//加载最外层的服务目录
                    services.getServeListMes({"parentNumber":''}).then(res => {
                        let nodes = [];
                        res.list.forEach(item=>{
                            nodes.push({value: item.serialNumber,title: item.title,leaf:!item.hasChildren})
                        })
                        if(res.list[0]){
                            return resolve(nodes);
                        }else{
                            return resolve([]);
                        }
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }else{//加载下级服务目录
                    services.getServeListMes({"parentNumber":node.data.value}).then(res => {
                        let nodes = [];
                        res.list.forEach(item=>{
                            nodes.push({value: item.serialNumber,title: item.title,leaf:!item.hasChildren})
                        })
                        if(res.list[0]){
                            return resolve(nodes);
                        }else{
                            return resolve([]);
                        }
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }
            },
            // 提交时详情默认显示
            getDetails(){
                commonService.getCorrectDetail({ serialNumber:this.parentNumber}).then(res => {
                    this.form = res;
                    this.label = res.label.join(",");
                    this.form.Title = res.title;
                    this.attachment = res.attachment;
                    let serveName=res.toService.map(item=>{return item.title})
                    // console.log(serviceName);
                    let serviceName=serveName.join(',')
                    // console.log(serviceName);
                    this.form.serveListName = serviceName;
                    this.serveListName = serviceName;
                    this.defaultCheckedValues=res.toService.map(item=>{return item.serialNumber})
                    // console.log(this.defaultCheckedValues);
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .serveList{
        display: inline-block;
        -width: 193px;
        height: 28px;
        border: 1px solid #CDCDC1;
        border-radius: 3px;
        padding-left: 15px;
        box-sizing: border-box;
        overflow: hidden;
        box-sizing: border-box;
    }
    .redColor{
        border: 1px solid red !important;
    }
    a.input {
        width:70px;
        height:30px;
        line-height:30px;
        background:#3091d1;
        text-align:center;
        display:inline-block;/*具有行内元素的视觉，块级元素的属性 宽高*/
        overflow:hidden;/*去掉的话，输入框也可以点击*/
        position:relative;/*相对定位，为 #file 的绝对定位准备*/
        top:10px;
    }
    a.input:hover {
        background:#31b0d5;
        color: #ffffff;
    }
    a{
        text-decoration:none;
        color:#FFF;
    }
    #file {
        opacity:0;/*设置此控件透明度为零，即完全透明*/
        filter:alpha(opacity=0);/*设置此控件透明度为零，即完全透明针对IE*/
        font-size:100px;
        position:absolute;/*绝对定位，相对于 .input */
        top:0;
        right:0;
    }
</style>
